import { Monitor, Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Field, FieldLabel } from '@/components/shadcn/field';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/shadcn/select';
import useLocalSettings from '@/stores/useLocalSettings';

export default function DarkModeSetting() {
  const { t } = useTranslation();

  const { darkMode, actions } = useLocalSettings();

  return (
    <Field>
      <FieldLabel>{t('SETTINGS_DARK_MODE')}</FieldLabel>

      <Select
        onValueChange={(value) =>
          actions.setDarkMode(value as 'DARK' | 'LIGHT' | 'SYSTEM')
        }
        value={darkMode}
      >
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>

        <SelectContent>
          <SelectItem value="SYSTEM">
            <Monitor />

            {t('SETTINGS_DARK_MODE_SYSTEM')}
          </SelectItem>

          <SelectItem value="DARK">
            <Moon />

            {t('SETTINGS_DARK_MODE_DARK')}
          </SelectItem>

          <SelectItem value="LIGHT">
            <Sun />

            {t('SETTINGS_DARK_MODE_LIGHT')}
          </SelectItem>
        </SelectContent>
      </Select>
    </Field>
  );
}
